<template>
    <a class="btn btn-success" id="submit-work" v-on:click="handleClick">
            {{ctaText}}
    </a>
    
</template>


<script>
export default {
    name: 'ProgressButton',
    props: {
        handlerFunc: Function,
        submitPressed: String
    },
    data: function() {
        return {
            ctaText: 'SUBMIT'
        }
    },
    methods: {
        handleClick: function() {
            this.ctaText = 'SUBMITTING...PLEASE WAIT';
            this.$emit('pressed', true);
        }
    }
}
</script>


<style scoped>

    @media (min-width: 993px) {
        #submit-work {
            margin-top:8%;
            padding-top:1.75%;
            padding-bottom:1.75%;
            padding-left:6%;
            padding-right:6%;
            justify-content: center;
            align-self: center;
            width:55%;
            margin-bottom:3%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 7px;
        }
    }
    
    @media (min-width: 769px) and (max-width: 992px) {
        #submit-work {
            margin-top:8%;
            padding-top:2.4%;
            padding-bottom:2.4%;
            padding-left:10%;
            padding-right:10%;
            justify-content: center;
            align-self: center;
            width:45%;
            margin-bottom:3%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 7px;
        }
    }

    @media (min-width: 501px) and (max-width: 768px) {
        #submit-work {
            margin-top:8%;
            padding-top:2.6%;
            padding-bottom:2.6%;
            padding-left:9%;
            padding-right:9%;
            justify-content: center;
            align-self: center;
            width:52%;
            margin-bottom:5%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 7px;
        }
    }

    @media (max-width: 500px) {
        #submit-work {
            margin-top:8%;
            padding-top:4%;
            padding-bottom:4%;
            padding-left:13%;
            padding-right:13%;
            justify-content: center;
            align-self: center;
            width:60%;
            margin-bottom:5%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 7px;
        }
    }
        
</style>
